import React from 'react';

import { Desktop } from './Desktop';
import { useModals } from 'components/ContextModals';
import { useAuth } from 'components/ContextAuth';

export const ModalAuth = () => {
  const { login } = useAuth();
  const { auth } = useModals();

  return <Desktop isOpen={auth.isOpen} onRequestClose={auth.close} login={login} />;
};
